import { Dispatch, SetStateAction, useCallback, useState } from "react";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import {
  LOGIN_STEP,
  LoginInfo,
} from "../../LoginContainer";
import ForgotEmailSent from "./ForgotEmailSent";
import ForgotEmail from "./ForgotEmail";
import useStatusMutation from "hook/useStatusMutation";
import { postForgotEmail } from "api/authAPI";
import useApiError from "hook/useApiError";

interface Props {
  step: LOGIN_STEP;
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeStep: (step: LOGIN_STEP) => void;
  setIsValidated: Dispatch<SetStateAction<Validate>>;
  setValidateMsg: Dispatch<SetStateAction<ValidateMsg>>;
  setLoginInfo: Dispatch<SetStateAction<LoginInfo>>;
}
export default function ForgotEmailContainer({
  step,
  loginInfo,
  isValidated,
  validateMsg,
  onChangeStep,
  setIsValidated,
  setValidateMsg,
  setLoginInfo,
}: Props) {
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const { notifyInfo, lang, intlString } = useApiError();
  const mutationForgotEmail = useStatusMutation(postForgotEmail, {
    onSuccess: () => {
      if (step === LOGIN_STEP.FORGOT_EMAIL_SENT) {
        notifyInfo(lang.label.login.forgotEmail.resend.sms);
      } else {
        onChangeStep(LOGIN_STEP.FORGOT_EMAIL_SENT);
      }
    },
    onError: () => {
      setIsValidated({ ...isValidated, tel: true });
      setValidateMsg({
        ...validateMsg,
        tel: intlString(lang.validateMsg.signup.noExistPhone),
      });
    },
  });
  const onClickSentEmail = useCallback(() => {
    if (!mutationForgotEmail.idle) return;
    mutationForgotEmail.mutate({
      payload: {
        phoneNumber: phoneNumber,
      },
    });
  }, [phoneNumber]);
  const onChangePhoneNumber = useCallback((number: string) => {
    setLoginInfo((info) => ({
      ...info,
      tel: number,
    }));
    setPhoneNumber(number);
  }, []);
  if (step === LOGIN_STEP.FORGOT_EMAIL) {
    return (
      <ForgotEmail
        onChangePhoneNumber={onChangePhoneNumber}
        onClickSentEmail={onClickSentEmail}
        isValidated={isValidated}
        validateMsg={validateMsg}
        onChangeStep={onChangeStep}
      />
    );
  }
  return (
    <ForgotEmailSent
      loginInfo={loginInfo}
      onClickSentEmail={onClickSentEmail}
      onChangeStep={onChangeStep}
    />
  );
}
